import { render, staticRenderFns } from "./articzw.vue?vue&type=template&id=30b7d9b7&scoped=true&"
import script from "./articzw.vue?vue&type=script&lang=js&"
export * from "./articzw.vue?vue&type=script&lang=js&"
import style0 from "./articzw.vue?vue&type=style&index=0&id=30b7d9b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b7d9b7",
  null
  
)

export default component.exports